import classcat from "classcat";
import React from "react";

import {
  Button,
  IconArrowLeft,
  IconEdit,
  IconX,
} from "@touchtech/web-baselayer-ui";

import css from "./DrawerActionButton.module.css";

export enum ActionButtonVariant {
  Close = "close",
  Back = "back",
  Edit = "edit",
}

type Props = {
  onClick?: () => void;
  isScrolled?: boolean;
  className?: string;
  variant?: ActionButtonVariant;
  onSecondaryButtonClick?: () => void;
  secondaryVariant?: ActionButtonVariant;
  secondaryClassName?: string;
};

const DrawerActionButton = ({
  onClick,
  isScrolled,
  className,
  variant = ActionButtonVariant.Close,
  onSecondaryButtonClick,
  secondaryVariant,
  secondaryClassName,
}: Props) => {
  const Icons = {
    [ActionButtonVariant.Close]: <IconX className={css.actionIcon} />,
    [ActionButtonVariant.Back]: <IconArrowLeft className={css.actionIcon} />,
    [ActionButtonVariant.Edit]: <IconEdit className={css.actionIcon} />,
  };

  return (
    <>
      {!!onSecondaryButtonClick && secondaryVariant && (
        <div
          className={classcat([css.containerLeft, secondaryClassName])}
          data-testid={secondaryVariant}
        >
          <Button
            onClick={onSecondaryButtonClick}
            rounded
            variant={isScrolled ? "secondary" : "tertiary"}
            sizing="lg"
            className={classcat({
              [css.actionButton]: !isScrolled,
              [css.scrolledActionButton]: isScrolled,
            })}
          >
            {Icons[secondaryVariant]}
          </Button>
        </div>
      )}

      {!!onClick && (
        <div
          className={classcat([css.container, className])}
          data-testid={variant}
        >
          <Button
            onClick={onClick}
            rounded
            variant={isScrolled ? "secondary" : "tertiary"}
            sizing="lg"
            className={classcat({
              [css.actionButton]: !isScrolled,
              [css.scrolledActionButton]: isScrolled,
            })}
          >
            {Icons[variant]}
          </Button>
        </div>
      )}
    </>
  );
};

export default DrawerActionButton;
